import { useEffect, useState } from 'react';

import { CircularProgress, Typography } from '@mui/material';

import { fetchCandidatesWithReviewStatus } from 'api';
import { OrganizationFullProps } from 'types';

export const CasesValidatedCell = (props: OrganizationFullProps) => {
  const { reviewable_candidate_count, id } = props;

  const [loading, setLoading] = useState(false);
  const [reviewedCandidateCount, setReviewedCandidateCount] = useState<
    number | null
  >(null);
  const candidateCount = reviewable_candidate_count || 0;

  useEffect(() => {
    const fetchDerogCandidates = async () => {
      try {
        setLoading(true);
        const { data } = await fetchCandidatesWithReviewStatus({
          params: {
            organization_id: id,
            review_status: [
              'did_not_work_certain',
              'did_not_work_insufficient_info',
              'reviewed_and_verified',
              'unable_to_review',
            ],
            limit: 0,
          },
        });
        setReviewedCandidateCount(data.length);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };
    if (candidateCount > 0) {
      fetchDerogCandidates();
    }
  }, [setLoading, id, setReviewedCandidateCount, candidateCount]);
  if (loading) {
    return <CircularProgress size={30} />;
  }

  return (
    <Typography variant='body1'>
      {reviewedCandidateCount === null
        ? ''
        : `${reviewedCandidateCount}/${candidateCount}`}{' '}
    </Typography>
  );
};
